/*!
 * KoliBri - The accessible HTML-Standard
 */
import { L as Log, d as de, w } from './common-D-vggmh2.js';
import { a as setMode } from './index-C_ZKddLG.js';

var appGlobalScript = () => {
    setMode((elm) => {
        try {
            if (elm.shadowRoot instanceof ShadowRoot) {
                de(elm, w(elm));
            }
        }
        catch (_a) {
        }
        return 'default';
    });
    import('./devtools-CAWyelfv.js')
        .then((devTools) => {
        if (typeof devTools === 'object' && devTools !== null && typeof devTools.initialize === 'function') {
            devTools.initialize();
        }
    })
        .catch((error) => {
        Log.error(error);
    });
};

const globalScripts = appGlobalScript;

export { globalScripts as g };
//# sourceMappingURL=app-globals-D_kl2ROP.js.map

//# sourceMappingURL=app-globals-D_kl2ROP.js.map